import { WatchDogPopupProps } from 'components/Blocks/Product/WatchDog/Popup/WatchDogPopup';
import Button from 'components/Forms/Button/Button';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import { useSessionStore } from 'store/useSessionStore';

const WatchDogPopup = dynamic<WatchDogPopupProps>(() =>
    import('components/Blocks/Product/WatchDog/Popup/WatchDogPopup').then((component) => component.WatchDogPopup),
);

type WatchDogProps = {
    productUuid: string;
    productName: string;
};

const WatchDog: FC<WatchDogProps> = (props) => {
    const { t } = useTranslation();
    const updatePortalContent = useSessionStore((s) => s.updatePortalContent);

    const onPopupOpenHandler = async () => {
        updatePortalContent(<WatchDogPopup productName={props.productName} productUuid={props.productUuid} />);
    };

    return (
        <>
            <Button
                className="w-fit"
                name="watch-product"
                size="smallNarrow"
                type="button"
                onClick={onPopupOpenHandler}
            >
                {t('Watch product')}
            </Button>
        </>
    );
};

export default WatchDog;
